import axios from 'axios';

/**
 * Recruiting engagement beacons — the web counterpart of
 * `OffersViewModel.beaconOpened` on iOS and Android.
 *
 * POSTs to `/athletes/<bucket>/opened`, which does no DB work: the backend's
 * UsageTrackingMiddleware records `recruiting_<bucket>_opened` off the request
 * (see backend/app/routers/athletes.py, "Recruiting engagement beacons"). It
 * replaced GET-on-load tracking, which counted every tab open as four phantom
 * views. Web fired none of these until now, so every bucket-engagement figure
 * under-counted by the whole web population.
 *
 * Fire-and-forget by design: both apps swallow the result (`try?` on iOS,
 * `runCatching` on Android). A failed beacon must never surface to the athlete
 * or block the editor they were opening.
 *
 * WEB SEMANTIC NOTE: the apps fire when an editor *sheet* opens — "+Add" or a
 * tap on a school row. Web edits rows inline, so there is no sheet to open. The
 * equivalent moments are "+Add" and the first actual edit to a given row, which
 * is what the callers use. Firing on focus instead would inflate the count as
 * the athlete tabs between fields in one row.
 */

const BUCKETS = ['offers', 'visits', 'following'];

export function beaconOpened(apiUrl, bucket) {
  if (!BUCKETS.includes(bucket)) return;
  const token = localStorage.getItem('token');
  if (!token) return;
  axios
    .post(`${apiUrl}/athletes/${bucket}/opened`, null, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .catch(() => {});
}

/**
 * Wraps `beaconOpened` so a bucket+row pair only ever beacons once per mount.
 * Pass a ref holding a Set; typing ten characters into one row is one edit
 * session, not ten.
 */
export function beaconRowOnce(seenRef, apiUrl, bucket, rowKey) {
  const key = `${bucket}:${rowKey}`;
  if (seenRef.current.has(key)) return;
  seenRef.current.add(key);
  beaconOpened(apiUrl, bucket);
}
